import { toast } from 'sonner';

/**
 * Centralised messaging surfaced whenever an AI action is blocked by the
 * current user's active GDPR Art. 21 objection on file.
 *
 * Keep copy and CTA in one place so every entry point (consent dialogs,
 * edge-function "skipped" responses, retry buttons, timeline messages)
 * communicates the same thing.
 */
export const AI_OBJECTION_COPY = {
  title: 'AI features are turned off',
  description:
    'You have an active objection to AI processing on file (GDPR Art. 21). Re-enable it in Settings to run AI reviews.',
  /** Same wording the server stores on skipped paper_processing_jobs rows. */
  jobMessage: 'Skipped — AI processing objection on file',
  /** Settings deep-link. */
  settingsHref: '/settings?tab=privacy#ai-processing',
  actionLabel: 'Open Settings',
};

/**
 * Fire a toast explaining that AI processing is disabled, with a one-click
 * link to Settings. Safe to call multiple times — sonner dedupes by id.
 */
export function showAIObjectionToast() {
  toast.error(AI_OBJECTION_COPY.title, {
    id: 'ai-objection-notice',
    description: AI_OBJECTION_COPY.description,
    action: {
      label: AI_OBJECTION_COPY.actionLabel,
      onClick: () => {
        if (typeof window !== 'undefined') {
          window.location.href = AI_OBJECTION_COPY.settingsHref;
        }
      },
    },
  });
}

/** Returns true when an edge-function response signals a GDPR objection skip. */
export function isGdprObjectionSkip(data: unknown): boolean {
  if (!data || typeof data !== 'object') return false;
  const d = data as { skipped?: unknown; reason?: unknown };
  return d.skipped === true && d.reason === 'gdpr_objection';
}
